export default __webpack_public_path__ + "static/media/oblivion.de10cb50.png";